
<div class="col-md-12 padding-left-0px padding-right-0px" *ngIf="mode=='view'">
  <div class="row margin-left-0px margin-right-0px" *ngIf="field">
    <div class="col-md-6 text-align-left  padding-left-0px padding-right-0px" >
      <label class="margin-bottom-0px font-family"> {{field.Title}}</label>
    </div>
  
  </div>

  <div class="row margin-left-0px margin-right-0px" *ngIf="field &&  Data  && Data.HasChildren">

    <auto-gen-childrenpv class="col-md-12 padding-left-0px padding-right-0px" [Data]="Data" [field]="Data.Data" [mode]="mode"></auto-gen-childrenpv>

  </div>

</div>



